// Do NOT add "use client" to this file
import { jsx as _jsx } from "react/jsx-runtime";
import { ProductImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductImage";
import { ProductImageWithSrcsetSizes } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductImageWithSrcsetSizes";
import * as React from "react";
export var TileImage = function(param) {
    var primaryImage = param.image, showVerticalImagery = param.showVerticalImagery, imageDimension = param.imageDimension, imageContainerRef = param.imageContainerRef, imageAltText = param.imageAltText, useLazyImageLoading = param.useLazyImageLoading, imageBreakpoints = param.imageBreakpoints, onLoad = param.onLoad;
    //Set the image dimension to match productImage -> COMMON_TILE_IMAGE_DIMENSION
    return /*#__PURE__*/ _jsx("div", {
        ref: imageContainerRef,
        "data-test-id": "carousel-image-".concat(primaryImage.token),
        children: imageBreakpoints ? /*#__PURE__*/ _jsx(ProductImageWithSrcsetSizes, {
            image: primaryImage,
            alt: imageAltText !== null && imageAltText !== void 0 ? imageAltText : "",
            loading: useLazyImageLoading ? "lazy" : undefined,
            sizes: imageBreakpoints,
            showVerticalImagery: showVerticalImagery,
            onLoad: onLoad
        }) : /*#__PURE__*/ _jsx(ProductImage, {
            image: primaryImage,
            imageDimension: imageDimension !== null && imageDimension !== void 0 ? imageDimension : {
                mobileAndAbove: 370,
                tabletAndAbove: 350,
                xLargeAndAbove: 300
            },
            showVerticalImagery: showVerticalImagery,
            alt: imageAltText !== null && imageAltText !== void 0 ? imageAltText : "",
            useLazyImageLoading: useLazyImageLoading,
            imageBreakpoints: imageBreakpoints,
            shouldIncrementallyLoadImages: true,
            onLoad: onLoad
        }, primaryImage.token)
    }, primaryImage.token);
};
